module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Ultra.cf00c76.eot";